export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_MENU = 'SET_MENU';
export const SHOW_IND_REG_FORM = 'SHOW_IND_REG_FORM';
